import { DatePicker, Popover, Select } from 'antd';
import FilterContent from 'common/FilterContent';
import { logoImagesMap } from 'components/constants/color';
import moment from 'moment';
import { CompareMetrics } from 'pages/Compare/CompareMetrics';
import CompareStatisticsReportDrawer from 'pages/ExportExcel/CompareStatisticsReportDrawer';
import CompareSurveyReportDrawer from 'pages/ExportExcel/CompareSurveyReportDrawer';
import { useEffect, useState } from 'react';
import { useApiLoaderStore } from 'store/apiLoderStore';
import { useFilterStore } from 'store/filterStore';
import { useNewStore } from 'store/newStore';
import { useStore } from 'store/store';
import ExportFileDialogue from '../ExportExcel/ExportFileDialogue';
import { SideBarContainer } from './Home.styled';

const { RangePicker } = DatePicker;

// const subEntityNames = [
//   'Country',
//   'States',
//   'Districts',
//   'Blocks',
//   'Clusters',
//   'Sub-groups',
// ];

function Home() {
  const [isNavOpen, setNavOpen] = useState(true),
    [dataSouceOptions, setDataSourceOptions] = useState<any>(),
    showLoader = useApiLoaderStore((state) => state.showLoader),
    [exportModalIsOpen, setExportModalIsOpen] = useState(false),
    [
      fetchDistinctDatasouce,
      distinctDataSources,
      selectedDataSouce,
      setSelectedDataSource,
      compareSurveyReportDrawerIsOpen,
      setCompareSurveyReportDrawerIsOpen,
      compareStatisticsReportDrawerIsOpen,
      setCompareStatisticsReportDrawerIsOpen,
    ] = useNewStore((state) => [
      state.fetchDistictDatasource,
      state.distinctDataSources,
      state.selectedDataSouce,
      state.setSelectedDataSource,
      state.compareSurveyReportDrawerIsOpen,
      state.setCompareSurveyReportDrawerIsOpen,
      state.compareStatisticsReportDrawerIsOpen,
      state.setCompareStatisticsReportDrawerIsOpen,
    ]),
    [startDate, setStartDate, endDate, setEndDate, setSelectedSessionNames] =
      useFilterStore((state) => [
        state.startDate,
        state.setStartDate,
        state.endDate,
        state.setEndDate,
        state.setSelectedSessionNames,
      ]);
  // queryParams = useQueryParams(),
  // currentClass = queryParams.get('class') || 'All',
  // currentSubject = queryParams.get('subject') || 'All';
  const [userData] = useStore((state) => [state.userData]);
  const todaysDate = moment(new Date(), 'DD/MM/YYYY');
  const oneYearOldDate = moment(
    new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    'DD/MM/YYYY'
  );
  useEffect(() => {
    setStartDate(oneYearOldDate);
    setEndDate(todaysDate);
  }, [setStartDate, setEndDate]);
  const handleDateRangeChange = function (dates: any) {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };
  useEffect(() => {
    if (!distinctDataSources) {
      fetchDistinctDatasouce(showLoader);
    }
  }, [fetchDistinctDatasouce, showLoader, distinctDataSources]);
  useEffect(() => {
    const selectDataSourceOptions =
      distinctDataSources &&
      distinctDataSources.map((dataSouce) => ({
        value: dataSouce,
        label: dataSouce,
      }));
    const updatedDataSouceOption = selectDataSourceOptions
      ? [...selectDataSourceOptions, { value: 'All', label: 'All' }]
      : [{ value: 'All', label: 'All' }];
    setDataSourceOptions(updatedDataSouceOption);
  }, [distinctDataSources, setDataSourceOptions]);
  // useEffect(() => {
  //   const filterParams = {
  //     selectedCountries: filterDto ? filterDto.selectedCountries : [],
  //     selectedStates: filterDto ? filterDto.selectedStates : [],
  //     selectedDistricts: filterDto ? filterDto.selectedDistricts : [],
  //     selectedBlocks: filterDto ? filterDto.selectedBlocks : [],
  //     selectedClusters: filterDto ? filterDto.selectedClusters : [],
  //     selectedSchoolGroups: filterDto ? filterDto.selectedSchoolGroups : [],
  //     startDate: startDate.unix(),
  //     endDate: endDate.unix(),
  //     dataSource: selectedDataSouce,
  //     grade: currentClass,
  //     subject: currentSubject,
  //   };
  //   showLoader(true);
  //   getFetchEntityWiseReport(filterParams, showToast).then((response) => {
  //     showLoader(false);
  //     if (response) {
  //       setCurrentEntityWisePerformance(response);
  //       setSubEntities(response.overall.names);
  //     }
  //   });
  // }, [
  //   filterDto,
  //   currentClass,
  //   currentSubject,
  //   showToast,
  //   setCurrentEntityWisePerformance,
  //   setSubEntities,
  //   showLoader,
  // ]);

  const hoverContent = (
    <div className="navbar-profile-info-container">
      <div className="navbar-profile-info-header-container">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          {userData && (
            <>
              <label className="navbar-profile-info-name">
                {userData.data.JSON.userName}
              </label>
              <label className="navbar-profile-info-email">
                Role : {userData.data.JSON.role}
              </label>
              <label className="navbar-profile-info-email">
                Access : {userData.data.acesss.names}
              </label>
            </>
          )}
        </div>
      </div>
    </div>
  );
  return (
    <div className="home-main-container">
      <div
        className="navbar-container"
        style={{
          justifyContent: selectedDataSouce in logoImagesMap ? '' : 'flex-end',
        }}
      >
        {selectedDataSouce in logoImagesMap && (
          <img
            src={
              selectedDataSouce in logoImagesMap
                ? logoImagesMap[selectedDataSouce]
                : ''
            }
            alt=""
            className="logo-img"
          />
        )}
        <div className="profile-container">
          <Popover
            placement="bottomRight"
            content={hoverContent}
            overlayStyle={{
              minWidth: '318px',
              minHeight: '248px',
              borderRadius: '4px',
            }}
          >
            <span className="profile-icon" style={{ display: 'flex' }}>
              {userData && userData.data.JSON.userName.charAt(0).toUpperCase()}
            </span>
          </Popover>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          justifyContent: 'space-between',
          backgroundColor: 'white',
          padding: '1rem',
          marginBottom: '1rem',
        }}
      >
        <label className="dashboard-label">Dashboard</label>
        <div className="flex-align-center gap-1rem">
          {userData && userData.data.JSON.role === 'ReportManager' && (
            <Select
              value={selectedDataSouce}
              style={{ flex: '1', width: '21rem' }}
              onChange={(value) => {
                setSelectedDataSource(value);
                setSelectedSessionNames([]);
              }}
              options={dataSouceOptions}
            />
          )}
          <RangePicker
            style={{ flex: '2', maxWidth: '21rem' }}
            defaultValue={[oneYearOldDate, todaysDate]}
            onChange={handleDateRangeChange}
            format="DD-MM-YYYY"
          />
          <img
            src="/images/filter_icon.svg"
            alt=""
            style={{ cursor: 'pointer', height: '32px' }}
            onClick={() => setNavOpen(!isNavOpen)}
          />
          <img
            src="/images/excel_download_icon.svg"
            alt=""
            style={{ cursor: 'pointer', height: '32px' }}
            onClick={() => setExportModalIsOpen(true)}
          />
        </div>
      </div>
      {exportModalIsOpen && (
        <ExportFileDialogue
          setIsOpen={setExportModalIsOpen}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      {compareSurveyReportDrawerIsOpen && (
        <CompareSurveyReportDrawer
          isOpen={compareSurveyReportDrawerIsOpen}
          setIsOpen={setCompareSurveyReportDrawerIsOpen}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      {compareStatisticsReportDrawerIsOpen && (
        <CompareStatisticsReportDrawer
          isOpen={compareStatisticsReportDrawerIsOpen}
          setIsOpen={setCompareStatisticsReportDrawerIsOpen}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      {distinctDataSources && (
        <div
          style={{
            display: 'flex',
            height: 'calc(100% - 10rem)',
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              width: '100%',
              padding: '1rem',
              height: '100%',
              margin: '0 1rem',
              borderRadius: '4px',
            }}
          >
            <CompareMetrics />
          </div>
          <SideBarContainer isOpen={isNavOpen}>
            <FilterContent
              isOpen={isNavOpen}
              startDate={startDate.unix()}
              endDate={endDate.unix()}
              selectedDataSouce={selectedDataSouce}
              setIsOpen={setNavOpen}
            />
            {/* {pathParams.length < 7 && (
              <div id="button_container">
                <Button
                  id="side_nav_icon"
                  onClick={() => setNavOpen(!isNavOpen)}
                  variant="outline-primary"
                >
                  {isNavOpen ? '<' : '>'}
                </Button>
              </div>
            )} */}
          </SideBarContainer>
        </div>
      )}
    </div>
  );
}

export default Home;
